import { useState, useEffect } from "react";
import Sidebar from '../../../componente/sidebar/index.jsx';
import "./style.css";
import api from "../../../services/api.js";
import { useAppContext } from '../../../context/AppContext.js';
import LoadingScreen from "../../../componente/aguarde";
import Impressora from "../../../assets/Impressora.png";
import ProdutoSetor from "../../../componente/produtosetor";

function RelPedido() {
    const { DateTime } = require("luxon");
    const [lista, setlista] = useState([]);
    const [listaProduto, setListaProduto] = useState([]);
    const [abusca, setabusca] = useState("");
    const [loading, setLoading] = useState(false);

    const dt = new Date();

    const date1 =
        dt.getFullYear() +
        "-" +
        (dt.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        dt.getDate().toString().padStart(2, "0");

    const date2 =
        dt.getFullYear() +
        "-" +
        (dt.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        dt.getDate().toString().padStart(2, "0");

    const [dt1, setdt1] = useState(date1);
    const [dt2, setdt2] = useState(date2);

    const { selectedCompany, accessKey } = useAppContext(); // Acessa os dados do contexto 

    const [codpedido, setCodPedido] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    async function ListarPedidoItens(cad) {
        setLoading(true);

        try {
            const response = await api.get("/v1/relatorio/pedido/pedidoitens", {
                params: {
                    codpedido: cad.codpedido
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            setListaProduto(response.data.produtos);

            setIsOpen(true);
        } catch (error) {
            console.log("ops! ocorreu um erro: " + error);
        } finally {
            setLoading(false);
        }
    }

    function ListarPedido() {
        api
            .get("/v1/relatorio/pedido", {
                params: {
                    busca: abusca,
                    codempresa: selectedCompany,
                    dt1,
                    dt2,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlista(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    useEffect(
        function () {
            ListarPedido();
        },
        [abusca, selectedCompany, dt1, dt2]
    );

    const imprimir = async () => {
        setLoading(true);

        try {
            const response = await api.get(`/v1/impressoes/relatorio/humor`, {
                responseType: "arraybuffer",
                params: {
                    busca: abusca,
                    codempresa: selectedCompany,
                    dt1,
                    dt2,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            link.click();
        } catch (error) {
            console.log("ops! ocorreu um erro: " + error);
        } finally {
            setLoading(false);
        }
    };

    function FormataDataHora(props) {
        return props
            ? DateTime.fromISO(props)
                .plus({ hours: 3 })
                .toFormat("dd/MM/yyyy HH:mm:ss")
            : null;
    }

    function FormataData(props) {
        return props
            ? DateTime.fromISO(props)
                .plus({ hours: 3 })
                .toFormat("dd/MM/yyyy")
            : null;
    }

    return (
        <>
            <div className="app-container">
                <Sidebar />
                <div className="content-container">
                    <div className="container-fluid">
                        <ProdutoSetor isOpen={isOpen} onClose={() => setIsOpen(false)} products={listaProduto} />

                        <div className="row">
                            <h1 className="ms-4">Relatório do Pedido</h1>
                            <p className="ms-4">Relatório dos pedidos e a situação em que se encontra</p>
                            <hr />
                        </div>

                        <div className="row">
                            <div className="col-xl-7 col-lg-7 col-md-6 col-sm-12">
                                <label className="form-label" htmlFor="busca">
                                    Busque aqui
                                </label>
                                <input
                                    type="text"
                                    placeholder="Buscar por: Núm. Pedido ou Cliente"
                                    name="busca"
                                    id="busca"
                                    className="form-control me-3"
                                    value={abusca}
                                    onChange={(e) => setabusca(e.target.value)}
                                />
                            </div>

                            <div className="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                <label htmlFor="dtlancamento" className="form-label">
                                    Lançamento de
                                </label>
                                <input
                                    type="date"
                                    id="dtlancamento"
                                    className="form-control"
                                    placeholder="Dt. Lançamento"
                                    value={dt1}
                                    onChange={(e) => setdt1(e.target.value)}
                                />
                            </div>

                            <div className="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                <label htmlFor="dtlancamento" className="form-label">
                                    Para...
                                </label>
                                <input
                                    type="date"
                                    id="dtlancamento"
                                    className="form-control"
                                    placeholder="Dt. Lançamento"
                                    value={dt2}
                                    onChange={(e) => setdt2(e.target.value)}
                                />
                            </div>

                            <div className="col-xl-1 col-lg-1 col-md-6 col-sm-12 d-flex justify-content-center">
                                <button type="button" className="btn" onClick={imprimir}>
                                    <img src={Impressora} alt="Imprimir" />
                                    <label>Imprimir</label>
                                </button>
                                {loading && <LoadingScreen />}
                            </div>
                        </div>

                        <div className="row mt-3">
                            <hr />
                        </div>

                        <div className="row tabela">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Núm. Pedido</th>
                                        <th>Dt. Pedido</th>
                                        <th>Dt. Conclusão</th>
                                        <th>Dt. Prev. Conclusão</th>
                                        <th>Cliente</th>
                                        <th>Pendente</th>
                                        <th>Progresso</th>
                                        <th className="acao">Ação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lista.map(function (item, index) {
                                        return (
                                            <tr key={index}>
                                                <th>{item.numpedido}</th>
                                                <th>{FormataData(item.dtpedido)}</th>
                                                <th>{FormataDataHora(item.dtconclusao)}</th>
                                                <th>{FormataDataHora(item.dtprevisaoconclusao)}</th>
                                                <th>{item.cliente}</th>
                                                <th>{item.pendente}</th>
                                                <th>{item.progresso}</th>
                                                <th>
                                                    <div className="d-flex justify-content-center">
                                                        <button
                                                            type="button"
                                                            className="btn fa-solid fa-eye"
                                                            onClick={() => ListarPedidoItens(item)}
                                                        ></button>
                                                    </div>
                                                </th>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colSpan={8}>Quantidade de Registros: {lista.length}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RelPedido;
